/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TestABRemoveIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Test AB Remove',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m4.819 17.782-1.308 3.986a.236.236 0 0 1-.262.193H.87c-.143 0-.19-.072-.167-.242L5.6 7.563a3.743 3.743 0 0 0 .214-1.3c0-.1.048-.169.143-.169h3.311c.119 0 .143.024.167.145l5.5 15.509c.024.145 0 .217-.143.217h-2.669a.238.238 0 0 1-.238-.145L10.5 17.782Zm4.925-2.633c-.5-1.594-1.618-4.952-2.094-6.643h-.024c-.381 1.619-1.332 4.445-2.046 6.643ZM15.407 23a12.315 12.315 0 0 1 3.454-5.1l3.35-12.723c.024-.1 0-.121-.095-.121h-2c-.1 0-.119 0-.144.1l-4.684 17.699c-.023.097 0 .145.119.145ZM27 14.8a12.365 12.365 0 0 1 1.7.132h.3a6.171 6.171 0 0 1 1.618.169 2.329 2.329 0 0 1 1.174.666 12.28 12.28 0 0 1 3.4 2.173 4.723 4.723 0 0 0 .09-.81 4.05 4.05 0 0 0-2.284-3.745 3.789 3.789 0 0 0 1.5-3.14c0-1.546-.762-4.2-5.734-4.2-1.594 0-3.759.048-4.615.072-.119.024-.143.1-.143.218v8.852A12.291 12.291 0 0 1 27 14.8Zm-.169-6.246c.5 0 1.118-.024 1.88-.024 1.95 0 3 .7 3 2.126a2.3 2.3 0 0 1-.9 1.908 14.426 14.426 0 0 0-2.165-.145h-1.815ZM27 18.1a8.9 8.9 0 1 0 8.9 8.9 8.9 8.9 0 0 0-8.9-8.9Zm5.826 12.267a.5.5 0 0 1 0 .707l-1.752 1.752a.5.5 0 0 1-.707 0L27 29.459l-3.367 3.367a.5.5 0 0 1-.707 0l-1.752-1.752a.5.5 0 0 1 0-.707L24.541 27l-3.367-3.367a.5.5 0 0 1 0-.707l1.752-1.752a.5.5 0 0 1 .707 0L27 24.541l3.367-3.367a.5.5 0 0 1 .707 0l1.752 1.752a.5.5 0 0 1 0 .707L29.459 27Z"
    />
  </svg>`;
};
